import React, { Component } from "react";
import {Card} from "react-bootstrap";
import "../../../CSS/AddReceiptStyles.css";
export default class DetailsBox extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    createGrid(selectedRow) {

    }


    render() {

        return (this.props.selectedRow) ?
            (
                <div style={{ maxWidth: "60vw" }}>

                    <Card >

                        <Card.Header style={{display: "inline-flex"}}>
                            <span style={{width: "150px", marginTop: "10px"}}>Receipt Line Detail</span> 

                        </Card.Header>

                        <Card.Body style={{ "auto" : "10px" }}>
                            <div className="details-grid-wrapper">
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.poolName}><span className="outer-label" ><p className="inner-label">Pool:</p>{this.props.selectedRow.poolName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.sizeName}><span className="outer-label" ><p className="inner-label">Size:</p>{this.props.selectedRow.sizeName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.labelName}><span className="outer-label" ><p className="inner-label">Label:</p>{this.props.selectedRow.labelName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.methodName}><span className="outer-label" ><p className="inner-label">Method:</p>{this.props.selectedRow.methodName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.blockName}><span className="outer-label" ><p className="inner-label">Block:</p>{this.props.selectedRow.blockName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.commodityName}><span className="outer-label" ><p className="inner-label">Commodity:</p>{this.props.selectedRow.commodityName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.styleName}><span className="outer-label" ><p className="inner-label">Style:</p>{this.props.selectedRow.styleName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.tagLineQty}><span className="outer-label" ><p className="inner-label">Line Quantity:</p>{this.props.selectedRow.tagLineQty}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.varietyName}><span className="outer-label" ><p className="inner-label">Variety:</p>{this.props.selectedRow.varietyName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.regionName}><span className="outer-label" ><p className="inner-label">Region:</p>{this.props.selectedRow.regionName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.growerName}><span className="outer-label" ><p className="inner-label">Grower:</p>{this.props.selectedRow.growerName}</span></p>
                                <p className="inner-grid-wrapper" key={this.props.selectedRow.storageName}><span className="outer-label" ><p className="inner-label">Storage:</p>{this.props.selectedRow.storageName}</span></p>

                            </div>


                        </Card.Body>

                    </Card>
                </div>
            ) : (<span />);
    }
}